import React from 'react'
import { Modal, Frame } from '@react95/core'
import { Heading, Text } from '@pancakeswap/uikit'
import { Progman21 } from '@react95/icons'
import { useTranslation } from 'contexts/Localization'

const LegalDisclaimerModal = ({ close, modalStyle, frameStyle }) => {
  const { t } = useTranslation()

  return (
    <Modal
      defaultPosition={{ x: 12, y: 12 }}
      icon={<Progman21 />}
      title="Legal Disclaimer & Risk Disclosure"
      closeModal={close}
      width="90vw"
      height="90vh"
      style={modalStyle}
      buttons={[{ value: 'Ok', onClick: close }]}
    >
      <Frame style={frameStyle}>
        <Heading scale="xl" mb="16px" mt="16px">
          {t(`Legal Disclaimer`)}
        </Heading>

        <Text fontSize="18px" mb="24px">
          {t(
            `The information provided on this website does not constitute investment advice, financial advice, trading advice, or any other sort of advice and you should not treat any of the content as such. The Windoge95 team does not recommend that any cryptocurrency should be bought, sold, or held by you.`,
          )}
        </Text>
        <Text fontSize="18px" mb="24px">
          {t(
            `Do conduct your own due diligence and consult your financial advisor before making any investment decisions. By purchasing Windoge95 token, you agree that you are not purchasing a security or investment and you agree to hold the team harmless and not liable for any losses or taxes you may incur. You also agree that the team is presenting the token “as is”, the team uses the contract at its discretion and is not required to provide any support or services. You should have no expectation of any form from Windoge95 token and its team. Although Windoge95 token is a community driven DeFi token for experimental reasons and not a registered digital currency, the team strongly recommends that citizens in areas with government bans on Crypto do not purchase it because the team cannot ensure compliance with your territories regulations. Always make sure that you are in compliance with your local laws and regulations before you make any purchase.`,
          )}
        </Text>

        <Text fontSize="18px" fontWeight="bold" mb="24px">
          {t(`Risk Disclosure`)}
        </Text>
        <Text fontSize="18px" mb="24px">
          {t(
            `Please note there are always risks associated with smart-contracts. Please use at your own risk. Windoge95 is not a registered broker, analyst or investment advisor. Everything that we provide on this website is purely for guidance, informational and educational purposes. All information contained herein should be independently verified and confirmed. We do not accept any liability for any loss or damage whatsoever caused in reliance upon such information or services. Please be aware of the risks involved with any trading done in any financial market. Do not trade with money that you cannot afford to lose. When in doubt, you should consult a qualified financial advisor before making any investment decisions.`,
          )}
        </Text>
      </Frame>
    </Modal>
  )
}

export default LegalDisclaimerModal
